var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['b2c', ("b2c-" + (_vm.$route.name))]},[_c('b2cHeader'),(_vm.s_market_info)?_c('router-view',{key:_vm.s_market_seq}):_vm._e(),(_vm.is_out_footer !== -2)?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }